import store from 'Store';

async function registerStoreModule(to, from, next) {
  const { default: storeModule } = await import(/* webpackChunkName: 'storeModuleNewsRoom' */ '../store');
  if (!store.hasModule('newsRoom')) {
    store.registerModule('newsRoom', storeModule);
  }
  next();
}

export default [
  {
    path: '/newsroom',
    name: 'newsroom',
    component: () => import(/* webpackChunkName: 'PageNewsRoomGeneral' */ '../PageNewsRoomGeneral'),
    beforeEnter: registerStoreModule,
    meta: {
      store: ['newsRoom/getNewsRoomData'],
    },
  },
  {
    path: '/newsroom/:slug',
    name: 'newsroom-post',
    component: () => import(/* webpackChunkName: 'PageNewsRoomSingle' */ '../PageNewsRoomSingle'),
    beforeEnter: registerStoreModule,
    meta: {
      store: ['newsRoom/getNewsRoomData', 'newsRoom/getNewsRoomPostData'],
      updateStoreData: true,
    },
  },
];
